import { init as initVariations } from './productVariations';
import { init as initPersonalization, personalizationData } from './productPersonalization';
import { AnimatedButton } from '@ts/components/AnimatedButton';
import { Modal } from '@ts/components/Modal';
import { checkCartEditableStatus } from './cart';

export const init = () => {
    initVariations();
    initPersonalization();
    setAddtoCartTrigger();
}

const addToCartSuccess = () => {
    const cartTrigger = document.querySelector('.nav-shopping-cart a');
    if (cartTrigger) {
        cartTrigger.dispatchEvent(new MouseEvent('click', {bubbles: true}));
    }
}

const setAddtoCartTrigger = () => {
    const addToCartBtn = AnimatedButton.getButton('add-to-cart');
    if (!addToCartBtn) return;
    addToCartBtn.setOnClick(async (e, btn) => {
        const addToCartData = gatherProductDetails();
        const isModifiable = await checkCartEditableStatus();

        if (!isModifiable) {
            Modal.createAlertModal({
                title: 'Error',
                message: 'Your cart is currently locked. Please complete checkout in your other tab or try again later.',
                closeBtnLabel: 'Close'
            });
            return false;
        }
        await postAddToCartData(addToCartData);
        return false;
    });
}

const postAddToCartData = async (data) => {
    const addToCartUrl = document.getElementById('add-to-cart')?.getAttribute('data-add-to-cart-url');  
    if (!addToCartUrl) return;

    try {
        const response = await fetch(addToCartUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            addToCartSuccess();
        } else {
            Modal.createAlertModal({
                title: 'Error',
                message: 'Failed to add product to cart. Please try again.',
                closeBtnLabel: 'Close'
            });
        }
    } catch (error) {
       Modal.createAlertModal({
            title: 'Error',
            message: error,
            closeBtnLabel: 'Close'
        });
    }
}   

const gatherProductDetails = () => {
    const productDetails = {}
    const quantity = document.getElementById('quantity');

    if (quantity) {
        productDetails.Quantity = quantity.value;
    }
    const productVariantId = document.getElementById('ProductVariantId');
    if (productVariantId) {
        productDetails.ProductVariantId = productVariantId.value;
    }
    if (personalizationData.length > 0) {
        productDetails.Personalizations = personalizationData;
    }
    return productDetails;
}